import { useEffect, useState } from "react";
import { getCourseStandardSets, getStandardSets } from "../../auth/api-client";

/** Resolve default standard set: course-linked, then URL hint, then first published. */
export function useDefaultStandardSetId(
  bearer: string | null,
  options?: { courseId?: string; urlStandardSetId?: string }
): { setId: string; loading: boolean } {
  const [setId, setSetId] = useState(options?.urlStandardSetId ?? "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!bearer) {
      setLoading(false);
      return;
    }
    (async () => {
      setLoading(true);
      try {
        if (options?.courseId) {
          const { standardSets } = await getCourseStandardSets(bearer, options.courseId);
          if (cancelled) return;
          if (standardSets.length > 0) {
            setSetId(standardSets[0].id);
            return;
          }
        }
        if (options?.urlStandardSetId) {
          setSetId(options.urlStandardSetId);
          return;
        }
        const { standardSets } = await getStandardSets(bearer);
        if (cancelled) return;
        setSetId(standardSets[0]?.id ?? "");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [bearer, options?.courseId, options?.urlStandardSetId]);

  return { setId, loading };
}
